import deprecatedPropType from '@mui/utils/deprecatedPropType';
export default deprecatedPropType;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/utils/deprecatedPropType.js
// module id = 1655
// module chunks = 22